import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  dialogContainer: {
    width: '100%',
    height: 'auto',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    boxSizing: 'border-box',
    backgroundColor: tokens.colorNeutralBackground2,
    overflow: 'hidden'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingHorizontalM,
    width: '100%',
    flex: '0 0 auto',
    paddingTop: '26px',
  },
  titleText: {
    fontFamily: 'Segoe UI',
    fontWeight: '600',
    fontSize: '28px',
    lineHeight: '36px',
    textAlign: 'center',
    color: tokens.colorNeutralForeground1Hover
  },
  cardsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    flex: '1 1 auto',
    paddingLeft: '40px',
    paddingRight: '40px',
    paddingTop: '26px',
    paddingBottom: '22px',
    boxSizing: 'border-box'
  },
  cards: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    justifyContent: 'center',
    width: '100%',
    alignItems: 'stretch'
  },
  benefitCard: {
    flex: '0 1 250px',
    minWidth: '0',
    maxWidth: '250px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: tokens.shadow4,
    borderRadius: tokens.borderRadiusMedium,
    alignItems: 'flex-start',
    gap: '8px',
    backgroundColor: tokens.colorNeutralBackground3,
    boxSizing: 'border-box',
  },
  cardImage: {
    width: '100%',
    height: 'auto',
    maxHeight: '140px',
    alignSelf: 'center',
    objectFit: 'contain'
  },
  imageContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '150px',
    marginBottom: '8px',
    overflow: 'hidden'
  },
  cardTitle: {
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '21px',
    color: tokens.colorNeutralForeground1Hover,
    width: '100%',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal'
  },
  cardDescription: {
    fontSize: '14px',
    lineHeight: '20px',
    color: tokens.colorNeutralForeground2,
    width: '100%',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal'
  },
  cardTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingBottom: '12px',
    gap: '4px',
    width: '100%',
    minWidth: '0',
    boxSizing: 'border-box'
  },
  buttonContainer: {
    paddingBottom: '22px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    flex: '0 0 auto'
  },
  button: {
    width: 'fit-content',
    minWidth: '120px',
    height: '32px',
  }
});